import type React from 'react';

import { Button, PaymentMethodIcon, PaymentMethodList } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { ShareSlideUp } from './components/ShareSlideUp';
import { usePromoteOrShareActions } from './hooks/usePromoteOrShareActions';

export const PromoteOrShareActions: React.FC = () => {
	const {
		data: {
			promoteButtonLabel,
			shareButtonLabel,
			promoteButtonUrl,
			shareButtonUrl,
			paymentMethods,
			isShareSlideUpEnabled,
			advocateEntryPointExperiment,
			advocateEntryPointUrl,
			advocateEntryPointButtonLabel,
			display,
		},
		actions: { handlePromoteClick, handleShareClick, handleAdvocateEntryPointClick },
	} = usePromoteOrShareActions();

	if (!display) {
		return null;
	}

	return (
		<>
			<div className="flex flex-col items-center gap-3 md:gap-4">
				<Button
					as="a"
					variant="primary"
					href={promoteButtonUrl}
					onClick={handlePromoteClick}
					className="w-full text-center"
					data-qa="promote-button"
				>
					{promoteButtonLabel}
				</Button>
				{advocateEntryPointExperiment ? (
					<Button
						as="a"
						variant="secondary"
						href={advocateEntryPointUrl}
						onClick={handleAdvocateEntryPointClick}
						className="w-full text-center"
						data-qa="advocate-button"
						data-testid="advocate-button"
					>
						{advocateEntryPointButtonLabel}
					</Button>
				) : (
					<>
						{isShareSlideUpEnabled && (
							/* The share slide-up is only visible on mobile. */
							<ShareSlideUp shareButtonLabel={shareButtonLabel} />
						)}
						{/* The share button is hidden on mobile to leverage the slide-up. */}
						<Button
							as="a"
							variant="secondary"
							href={shareButtonUrl}
							onClick={handleShareClick}
							className={cn('w-full text-center', { 'hidden md:block': isShareSlideUpEnabled })}
							data-qa="share-button"
							data-testid="share-button"
						>
							{shareButtonLabel}
						</Button>
					</>
				)}
			</div>
			<PaymentMethodList
				className="mx-auto grid grid-cols-4 items-center justify-items-center gap-2 md:flex md:flex-wrap md:justify-center"
				data-qa="payment-methods"
			>
				{paymentMethods.map((paymentType) => (
					<PaymentMethodIcon key={paymentType} type={paymentType} variant="card" />
				))}
			</PaymentMethodList>
		</>
	);
};
